<template>
<svg viewBox="0 0 49 51" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-custom-image`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_0d4d6f3798__clip0_0:4720)"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 4a2 2 0 00-2 2v35.5a2 2 0 002 2h38a2 2 0 002-2v-31a2 2 0 00-2-2H21V6a2 2 0 00-2-2H5zm2 12V8h10v4.5h24V16H7zm0 4v19.5h34V20H7z"/><path d="M24 20h22v30.743H24V20z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M30.243 39.728v-3.58l.218-.222 3.802 3.802h-4.02zm6.854-2.824l5.27-5.365-3.84-3.84-5.265 5.37 3.835 3.835zm-10.854 6.824v-9.213l12.257-12.5 9.5 9.5-12 12.213h-9.757z"/></g><defs><clipPath id="svg_0d4d6f3798__clip0_0:4720"><path d="M0 0h48.106v50.743H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconCustomImage',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
